import { render, staticRenderFns } from "./order_delivery.vue?vue&type=template&id=7274a15c&scoped=true"
import script from "./order_delivery.vue?vue&type=script&lang=js"
export * from "./order_delivery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7274a15c",
  null
  
)

export default component.exports